var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.19 3.81C12.78.4 7.22.4 3.81 3.81s-3.41 8.97 0 12.38A8.721 8.721 0 0 0 10 18.75c2.24 0 4.48-.85 6.19-2.56 3.41-3.41 3.41-8.96 0-12.37v-.01Zm-.88 11.49c-2.92 2.92-7.68 2.92-10.61 0-2.92-2.92-2.92-7.68 0-10.61A7.472 7.472 0 0 1 10 2.5c1.92 0 3.84.73 5.3 2.19 2.92 2.92 2.92 7.68 0 10.61h.01Zm-.55-5.3c0 .35-.28.62-.62.62h-3.5v3.5c0 .35-.28.62-.62.62-.34 0-.62-.28-.62-.62v-3.5H5.9c-.35 0-.62-.28-.62-.62 0-.34.28-.62.62-.62h3.5v-3.5c0-.35.28-.62.62-.62.34 0 .62.28.62.62v3.5h3.5c.35 0 .62.28.62.62Z",
    fill: "current"
  })));
};
export default SvgAdd;